<div class="row">
    <div class="col-3">
        <app-control label='FSPD Receipt Date' type="datetime" [isDisabled]="true" [(ngModel)]="fspdReceivedDate"/>                             
    </div>

    <div class="col-3">
        <app-control label="FSPD Receipt By" type="string" [isDisabled]="true" [ngModel]="fspdReceivedByFullName"/>                                
    </div>

    <div class="col-6">
        <app-control label="FSDP Remark" type="string" [(ngModel)]="fspdRemark" [isDisabled]="true"/>                                
    </div>
</div>

<div class="row">
    <div class="col-3">
        <app-control label="Captain's Office Receipt Date" type="datetime" [isDisabled]="true" [(ngModel)]="captainReceivedDate"/>                             
    </div>

    <div class="col-3">
        <app-control label="Captain's Office Receipt By" type="string" [isDisabled]="true" [ngModel]="captainReceivedByFullName"/>                                
    </div>

    <div class="col-6">
        <app-control label="Captain's Office Remark" type="string" [(ngModel)]="captainRemark" [isDisabled]="true"/>                                
    </div>
</div>
